export default __webpack_public_path__ + "static/media/dia14.0e9bf01e.png";